<template>
  <a-config-provider>
    <template #renderEmpty>
      <a-empty :description="emptyText" />
    </template>

    <a-list
      class="list c-list"
      :loading="loading"
      itemLayout="horizontal"
      :pagination="pagination"
      :dataSource="results"
    >
      <list-cols-header
        slot="header"
        :headers="headers"
        :actions-cols="2"
        :col-spans="[8, 10, 6]"
        @sort="handleSort"
      />

      <a-list-item slot="renderItem" slot-scope="item">
        <a-row type="flex" class="item-row" :gutter="24">
          <a-col span="8">
            <a-list-item-meta>
              <a slot="title">
                <router-link :to="getEditRoute(item)">
                  {{ item.name }}
                </router-link>
              </a>
              <span slot="description">
                {{ item.language }} |
                {{ item.level }}
              </span>
            </a-list-item-meta>
          </a-col>

          <a-col span="10" class="students-col">
            <a-list-item-meta v-if="isStudent">
              <a-avatar slot="avatar" icon="user" :src="item.lecturer.avatar" />
              <span slot="title">
                {{ item.lecturer.full_name }}
              </span>
            </a-list-item-meta>
            <a-list-item-meta v-else-if="item.students.length === 1">
              <a-avatar
                slot="avatar"
                icon="user"
                :src="item.students[0].avatar"
              />
              <span slot="title">
                {{ item.students[0].full_name }}
              </span>
            </a-list-item-meta>
            <a-list-item-meta v-else>
              <a-avatar slot="avatar" icon="team" />
              <span slot="title">
                {{ item.students.map(student => student.full_name).join(', ') }}
              </span>
            </a-list-item-meta>
          </a-col>

          <a-col span="6">
            <a-list-item-meta>
              <span slot="title">
                <a-progress :percent="item.progress" />
              </span>
              <span slot="description" class="progress-description">
                {{ item.hours_elapsed }}h / {{ item.hours }}h
              </span>
            </a-list-item-meta>
          </a-col>
        </a-row>

        <a slot="actions">
          <a-button
            type="link"
            icon="message"
            @click="() => openChat(item.room)"
          />
        </a>

        <a slot="actions">
          <a-dropdown :trigger="['click']">
            <a-button type="link" icon="more" class="ant-dropdown-link" />
            <a-menu slot="overlay">
              <a-menu-item v-for="(action, i) in actions(item)" :key="i">
                <router-link
                  v-if="action.type === 'router-link'"
                  :to="action.to"
                >
                  {{ action.text }}
                </router-link>
                <a v-else @click="action.onClick">
                  {{ action.text }}
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a>
      </a-list-item>
    </a-list>
  </a-config-provider>
</template>
<script>
export default {
  queryModels: ['ordering'],
  props: {
    results: Array,
    pagination: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    getEditRoute: {
      type: Function,
      default: item => {
        return `/admin/kursy/szczegoly/${item.id}/edytuj/`
      }
    },
    actions: {
      type: Function,
      default: () => []
    },
    emptyText: {
      type: String,
      default: 'Brak kursów'
    }
  },
  computed: {
    headers() {
      return [
        {
          title: 'Kurs',
          sort: true,
          key: 'name'
        },
        {
          title: this.isStudent ? 'Lektor' : 'Kursanci'
        },
        {
          title: 'Postęp'
        }
      ]
    }
  },
  methods: {
    handleSort(order) {
      this.ordering = order || undefined
    }
  }
}
</script>
<style scoped lang="scss">
.progress-description {
  text-align: center;
  font-size: 12px;
  width: 100%;
  display: block;

  padding-right: 36px;
}

.list {
  margin-top: 40px;
}

.item-row {
  flex: 1;
  width: 100%;
}

.students-col {
  display: flex;

  ::v-deep .ant-list-item-meta-title {
    font-size: 15px;
  }
}
</style>
